import { CashTransaction } from '../../types/cash-transaction.types';
import { TransactionCard } from './TransactionCard';

interface RecentTransactionsProps {
  transactions: CashTransaction[];
}

export function RecentTransactions({ transactions }: RecentTransactionsProps) {

  if (transactions.length === 0) {
    return (
      <div className="px-6 py-8 text-center text-gray-500">
        <p>No hay transacciones recientes</p>
        <p className="text-sm mt-2">Las transacciones aparecerán aquí cuando las realices</p>
      </div>
    );
  }

  return (
    <div className="divide-y divide-gray-200">
      {transactions.map((transaction) => (
        <div key={transaction.id} className="px-6 py-4 hover:bg-gray-50 transition-colors">
          <TransactionCard transaction={transaction} />
        </div>
      ))}
    </div>
  );
}

export default RecentTransactions;
